import React from 'react';
import styles from './NewsItem.module.scss';
// import images from "../../../../../../images/test-town_6.jpg";
import { Link, useLocation } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
import { formatDate } from '../../../../../../functions/formatDate';

const NewsItem = (props) => {
  const { ref, inView, entry } = useInView({
    threshold: 0.9,
    triggerOnce: true,
  });

  const oldDate = props.date;

  const location = useLocation();

  return (
    <li ref={ref} className={styles.item}>
      {entry?.isIntersecting ? (
        <>
          <Link to={location.pathname + '/' + props.id}>
            <div className={styles.image}>
              <img src={props.img} alt="" className={styles.image} />
            </div>

            <p className={styles.date}>{formatDate(oldDate)}</p>
            <p className={styles.title}>{props.title}</p>
          </Link>
        </>
      ) : (
        <div className={styles.skeleton} />
      )}
    </li>
  );
};

export default NewsItem;
